import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';

const API_GET_CUSTOMERS = 'https://app.mirzawaleed.com/getCustomers.php';
const API_GET_BOOKERS = 'https://app.mirzawaleed.com/getBookers.php';
const API_ADD_RECEIVED = 'https://app.mirzawaleed.com/addReceived.php';

const CustomerReceivePage = () => {
  const [customers, setCustomers] = useState([]);
  const [bookers, setBookers] = useState([]);

  const [selectedCustomer, setSelectedCustomer] = useState('');
  const [selectedBooker, setSelectedBooker] = useState('');
  const [date, setDate] = useState('');
  const [time, setTime] = useState('');
  const [amount, setAmount] = useState('');

  // Fetch customers
  useEffect(() => {
    fetchCustomers();
    fetchBookers();
  }, []);

  const fetchCustomers = async () => {
    try {
      const response = await fetch(API_GET_CUSTOMERS);
      const result = await response.json();
      setCustomers(result);
    } catch (error) {
      console.error('Error fetching customers:', error);
    }
  };

  const fetchBookers = async () => {
    try {
      const response = await fetch(API_GET_BOOKERS);
      const result = await response.json();
      setBookers(result);
    } catch (error) {
      console.error('Error fetching bookers:', error);
    }
  };

  const handleSubmit = async () => {
    if (!selectedCustomer || !selectedBooker || !date || !amount) {
      alert('Please fill all fields');
      return;
    }

    try {
      const response = await fetch(API_ADD_RECEIVED, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customer_id: selectedCustomer,
          booker_id: selectedBooker,
          recovery_by: "Direct",
          date,
          time,
          amount,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert('✅ Amount received saved successfully!');
        // reset form
        setSelectedCustomer('');
        setSelectedBooker('');
        setDate('');
        setTime('');
        setAmount('');
      } else {
        alert('❌ Error: ' + (result.message || 'Something went wrong'));
      }
    } catch (error) {
      console.error('Error submitting:', error);
      alert('❌ Network error, try again');
    }
  };

  return (
    <>
      <Header />
      <div style={{ padding: '20px' }}>
        <h2>Customer Received Entry</h2>

        {/* Select Customer */}
        <div style={{ marginBottom: '15px' }}>
          <label>Customer:</label>
          <select
            value={selectedCustomer}
            onChange={(e) => setSelectedCustomer(e.target.value)}
            style={{ marginLeft: '10px', padding: '8px', width: '300px' }}
          >
            <option value="">-- Select Customer --</option>
            {customers.map((cust) => (
              <option key={cust.id} value={cust.id}>
                {cust.name}
              </option>
            ))}
          </select>
        </div>

        {/* Date & Time */}
        <div style={{ marginBottom: '15px' }}>
          <label>Date:</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            style={{ marginLeft: '10px', padding: '8px' }}
          />
        </div>
        <div style={{ marginBottom: '15px' }}>
          <label>Time:</label>
          <input
            type="time"
            value={time}
            onChange={(e) => setTime(e.target.value)}
            style={{ marginLeft: '10px', padding: '8px' }}
          />
        </div>

        {/* Received Amount */}
        <div style={{ marginBottom: '15px' }}>
          <label>Received Amount:</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="Enter amount"
            style={{ marginLeft: '10px', padding: '8px', width: '200px' }}
          />
        </div>

        {/* Select Booker */}
        <div style={{ marginBottom: '15px' }}>
          <label>Booker:</label>
          <select
            value={selectedBooker}
            onChange={(e) => setSelectedBooker(e.target.value)}
            style={{ marginLeft: '10px', padding: '8px', width: '300px' }}
          >
            <option value="">-- Select Booker --</option>
            {bookers.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </select>
        </div>

        {/* Submit */}
        <button
          onClick={handleSubmit}
          style={{
            padding: '10px 20px',
            backgroundColor: 'green',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
          }}
        >
          Submit
        </button>
      </div>
      <Footer />
    </>
  );
};

export default CustomerReceivePage;
